module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contentBuilderModule flex-row"
  }, [_c('svg', {
    attrs: {
      "id": "builderShelf",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-edit-shelf"
  }, [_c('div', {
    staticClass: "content-edit-shelf-input"
  }, [_c('div', {
    staticClass: "content-edit-shelf-input-counter-char"
  }, [_vm._v(_vm._s(_vm.lengthChar) + " / " + _vm._s(_vm.maxlengthChar) + " CHARACTERS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getText),
      expression: "getText"
    }],
    attrs: {
      "type": "text",
      "maxlength": _vm.maxlengthChar
    },
    domProps: {
      "value": (_vm.getText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.clearText
    }
  }, [_vm._v("CLEAR")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dafeeb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/ShelfEditor.vue
// module id = 3213
// module chunks = 0